// extracted by mini-css-extract-plugin
module.exports = {"overlay":"tip_overlay__HYh4X","content":"tip_content__IQlcF","button":"tip_button__jvQl2","buttonContainer":"tip_buttonContainer__qN4t8"};